import _ from "lodash";
import Vue from "vue";

// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./log.worker";

import store from "@/store/index";
import * as env from "../utils/env";

import bridge from "@/api/bridge";

Vue.use({
	async install(Vue) {
		Vue.prototype.$log = text => {
			const inMobileApp = store.getters["config/inMobileApp"];

			if (inMobileApp) {
				bridge.send("console", [text]);
			}

			console.log(text);
			this.insert(text);
		};

		this.worker = new Worker();
		this.worker.postMessage({
			type: "init",
		});

		setInterval(() => {
			this.worker.postMessage({
				type: "upload",
			});
		}, 30000);

		this.env = {
			stage: env.getEnvironment(),
			version: env.getWebVersion(),
		};
	},

	insert(text) {
		const user = store.getters["auth/id"];
		const name = store.getters["auth/fullName"];

		let community = store.getters["session/community"];
		community = _.get(community, "name");

		let system = store.getters["session/system"];
		system = _.get(system, "name");

		text = typeof text !== "string" ? JSON.stringify(text) : text;

		this.worker.postMessage({
			type: "insert",
			payload: {
				user,
				name,
				text,
				env: this.env,
				ctx: {
					community,
					system,
				},
				timestamp: new Date().toISOString(),
			},
		});
	},
});
